import React from "react";
import Header from "../components/Layouts/Header";
import Footer from "../components/Layouts/Footer";
import CourseViewDetails from "../components/CourseViewDetails/CourseViewDetails";

const CourseDetails = () => {
  return (
    <>
      <Header />
      <CourseViewDetails />
      <Footer />
    </>
  );
};

export default CourseDetails;
